import React, { useState } from 'react';
import { returnRequestService } from '../services/api';
import './RefundRequestForm.css';

const REASONS = [
  { value: 'wrong_product', label: 'Recibí un producto distinto al que pedí' },
  { value: 'quality_defect', label: 'Defecto de calidad o producto dañado' },
  { value: 'shipping_damage', label: 'Daño durante el transporte' },
  { value: 'expired_or_near_expiry', label: 'Producto vencido o muy próximo a vencer' },
  { value: 'other', label: 'Otro motivo (descríbelo abajo)' },
];

const RefundRequestForm = () => {
  const [form, setForm] = useState({
    orderNumber: '',
    fullName: '',
    email: '',
    phone: '',
    city: '',
    reason: 'quality_defect',
    productsText: '',
    issueDescription: '',
    preferredResolution: 'refund',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const res = await returnRequestService.submit(form);
      const code = res?.data?.requestCode ?? res?.requestCode;
      setSuccess(code || 'registrada');
      setForm({
        orderNumber: '',
        fullName: '',
        email: '',
        phone: '',
        city: '',
        reason: 'quality_defect',
        productsText: '',
        issueDescription: '',
        preferredResolution: 'refund',
      });
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'No se pudo enviar la solicitud.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="refund-form-success" role="status">
        <i className="fas fa-check-circle" aria-hidden="true" />
        <h4>Solicitud registrada</h4>
        <p>
          Tu código de seguimiento es <strong>{success}</strong>. Revisaremos tu caso y te escribiremos a tu correo en un máximo de <strong>2 días hábiles</strong>.
        </p>
        <button type="button" className="refund-form-btn refund-form-btn--secondary" onClick={() => setSuccess(null)}>
          Enviar otra solicitud
        </button>
      </div>
    );
  }

  return (
    <form className="refund-request-form" onSubmit={onSubmit} noValidate>
      <p className="refund-form-lead">
        Completa este formulario para iniciar tu devolución, cambio o garantía. Es el canal oficial para pedidos de la tienda Javiland.
      </p>

      <div className="refund-form-grid">
        <label className="refund-form-field">
          <span>Número de pedido *</span>
          <input name="orderNumber" value={form.orderNumber} onChange={onChange} required placeholder="Ej. JAV-2026-00042" />
        </label>
        <label className="refund-form-field">
          <span>Nombre completo *</span>
          <input name="fullName" value={form.fullName} onChange={onChange} required autoComplete="name" />
        </label>
        <label className="refund-form-field">
          <span>Correo electrónico *</span>
          <input type="email" name="email" value={form.email} onChange={onChange} required autoComplete="email" />
        </label>
        <label className="refund-form-field">
          <span>Celular *</span>
          <input type="tel" name="phone" value={form.phone} onChange={onChange} required autoComplete="tel" />
        </label>
        <label className="refund-form-field">
          <span>Ciudad *</span>
          <input name="city" value={form.city} onChange={onChange} required autoComplete="address-level2" />
        </label>
        <label className="refund-form-field">
          <span>Motivo de la solicitud *</span>
          <select name="reason" value={form.reason} onChange={onChange} required>
            {REASONS.map((r) => (
              <option key={r.value} value={r.value}>{r.label}</option>
            ))}
          </select>
        </label>
      </div>

      <label className="refund-form-field refund-form-field--full">
        <span>Productos (nombre, presentación y cantidad) *</span>
        <textarea
          name="productsText"
          value={form.productsText}
          onChange={onChange}
          required
          rows={3}
          placeholder="Ej. Sal Himalaya molida 250g — 1 unidad; Shampoo sólido — 1 unidad"
        />
      </label>

      <label className="refund-form-field refund-form-field--full">
        <span>Describe qué ocurrió</span>
        <textarea
          name="issueDescription"
          value={form.issueDescription}
          onChange={onChange}
          rows={4}
          placeholder="Cuéntanos el detalle. Si hay defecto de calidad, indica si puedes enviar fotos por correo cuando te contactemos."
        />
      </label>

      <fieldset className="refund-form-resolution">
        <legend>¿Qué prefieres?</legend>
        <label>
          <input
            type="radio"
            name="preferredResolution"
            value="refund"
            checked={form.preferredResolution === 'refund'}
            onChange={onChange}
          />
          Reembolso (mismo medio de pago)
        </label>
        <label>
          <input
            type="radio"
            name="preferredResolution"
            value="replacement"
            checked={form.preferredResolution === 'replacement'}
            onChange={onChange}
          />
          Reemplazo del mismo producto
        </label>
      </fieldset>

      {error && <p className="refund-form-error" role="alert">{error}</p>}

      <button type="submit" className="refund-form-btn" disabled={submitting}>
        {submitting ? 'Enviando…' : 'Enviar solicitud'}
      </button>
    </form>
  );
};

export default RefundRequestForm;
